import React, { useCallback, useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import SubmitButton from "../Common/buttons/SubmitButton";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Form } from "react-bootstrap";
import { ApiHook } from "../../hooks/apiHook";
// import { Select } from "antd";
import AsyncSelect from 'react-select/async';
// import Select from 'react-select';
import { BASE_URL, DEFAULT_KEY } from "../../config/config";
// import Select from 'react-select';

const TreeViewNavbar = ({ menu, searchUsername, setSearchUsername, setSelectedUserId, setShowSearchLoader, setSearchUserId }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const debounceTimerRef = useRef(null);
  const selectInputRef = useRef();
  const pathname = location.pathname;
  const trimmedPathname = pathname.replace(/^\//, "");
  const [username, setUsername] = useState(undefined);
  const [usernameId, setUsernameId] = useState(undefined);
  const [selectedMenu, setSelectedMenu] = useState(false);
  const [optionList, setOptionList] = useState([])
  const [searchValue, setSearchValue] = useState('')
  const [inputValue, setInputValue] = useState('');
  const getUsers = ApiHook.CallUsersList(searchValue, trimmedPathname);  // API

  // if (location.pathname === "/sponsor-tree") {
  //   ApiHook.CallSponsorTreeList("", "", searchUsername);
  // } else if (location.pathname === "/genealogy-tree") {
  //   ApiHook.CallGenealogyTreeList("", "", searchUsername);
  // } else {
  //   //  Do nothing
  // }
  const plan = useSelector(
    (state) => state.dashboard?.appLayout?.moduleStatus?.mlm_plan
  );



  const handleChange = (value) => {
    console.log("🚀 ~ handleChange ~ value:", value.label)
    setUsername(value.label);
    setSearchValue(value.label);
    setUsernameId(value.value);
    setInputValue(value.label);
  };
  const handleSearch = () => {
    setSearchUsername(username);
    setSearchUserId(usernameId)
  };
  const handleReset = () => {
    // selectInputRef.current.select.clearValue();
    setSearchUsername("");
    setUsername(undefined);
    setUsernameId(undefined);
    setSelectedUserId("");
    setSearchUserId("")
    setInputValue('');

  }

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      // If Enter key is pressed, trigger the search
      handleSearch();
    }
  };
  const handleSideMenuToggle = () => {
    setSelectedMenu(!selectedMenu);
  };


  // react-select

  const loadOptions = async (inputValue) => {
    try {
      const response = await fetch(`${BASE_URL}get-users-list?type=${trimmedPathname}&search=${inputValue}`,
        {
          method: 'GET', // or 'POST', 'PUT', etc. depending on your API requirements
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'api-key': DEFAULT_KEY,
            'access-token': localStorage.getItem("access-token") || "",
          }
        });
      const data = await response.json();

      // Assuming the API returns an array of objects with 'id' and 'name' properties
      const listOption = data?.data.map(item => ({
        value: item.id,
        label: item.fullname
      }));
      setOptionList(listOption)
      return listOption;
    } catch (error) {
      console.error('Error fetching options:', error);
      return [];
    }
  };


  const debouncedLoadOptions = useCallback((inputValue, callback) => {
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    debounceTimerRef.current = setTimeout(() => {
      loadOptions(inputValue).then(callback);
    }, 500);
  }, []);

  return (
    <>
      <div className="page_head_top">
        {t(menu)}
        <div className="right_btn_mob_toggle" onClick={handleSideMenuToggle}>
          <i className="fa fa-bars"></i>
        </div>
      </div>
      <div
        className={`tree_view_top_filter_bar mt-2 hide_show_mobile ${selectedMenu ? "show_mn" : ""
          }`}
      >
        <div className="row justify-content-between">
          <div
            className={`col-md-8 hide_show_mobile ${selectedMenu ? "show_mn" : ""
              }`}
          >
            <NavLink
              to="/genealogy-tree"
              className={({ isActive }) =>
                isActive ? "btn_ewallt_page active" : "btn_ewallt_page"
              }
            >
              {t("genealogyTree")}
            </NavLink>
            {plan !== "Unilevel" && (
              <NavLink
                to="/sponsor-tree"
                className={({ isActive }) =>
                  isActive ? "btn_ewallt_page active" : "btn_ewallt_page"
                }
              >
                {t("sponsorTree")}
              </NavLink>
            )}
            <NavLink
              to={"/tree-view"}
              className={({ isActive }) =>
                isActive ? "btn_ewallt_page active" : "btn_ewallt_page"
              }
            >
              {t("treeView")}
            </NavLink>
            <NavLink
              to={"/downline-members"}
              className={({ isActive }) =>
                isActive ? "btn_ewallt_page active" : "btn_ewallt_page"
              }
            >
              {t("downlineMembers")}
            </NavLink>
            {plan !== "Unilevel" && (
              <NavLink
                to={"/referral-members"}
                className={({ isActive }) =>
                  isActive ? "btn_ewallt_page active" : "btn_ewallt_page"
                }
              >
                {t("referralMembers")}
              </NavLink>
            )}
          </div>
          {(trimmedPathname === "genealogy-tree" ||
            trimmedPathname === "sponsor-tree") && (
              <div className="col-md-4 mob_filter_right ">
                <div className="right_search_div d-flex gap-1 nav-bar-flex">
                  <Form.Group>
                    <div style={{ width: '250px' }}>
                      <AsyncSelect
                        ref={selectInputRef}
                        cacheOptions
                        loadOptions={debouncedLoadOptions}
                        placeholder="Search User..."
                        styles={{ width: '100%' }}
                        onChange={handleChange}
                        // loadOptions={loadOptions}
                        // defaultOptions
                        // onInputChange={handleInputChange}
                        // inputValue={searchValue}
                        // inputValue={inputValue}
                        // onInputChange={(value) => setInputValue(value)}
                      />
                    </div>
                  </Form.Group>
                  <SubmitButton
                    className="btn btn-primary"
                    text="search"
                    click={handleSearch}
                  />
                  <SubmitButton
                    className="btn btn-secondary"
                    text="reset"
                    click={handleReset}
                  />
                </div>
              </div>
            )}
        </div>
      </div>
    </>
  );
};

export default TreeViewNavbar;